export default function VisionsSection({ visions }) {
    if (!visions?.length) return null;

    return (
        <div className="grid-2-cols mt-8">
            {visions.map((vision, index) => (
                <div className="about-box" key={index}>
                    <h3 className="about-box-title">{vision.name}</h3>
                    <p className="about-box-desc">{vision.content}</p>
                </div>
            ))}
        </div>
    );
}